exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-cursor {\n  cursor: pointer;\n}\n.btn-generate {\n  float: right;\n  position: relative;\n  top: -10px;\n  cursor: pointer;\n}\n.btn-generate:hover {\n  color: #4e73df;\n}\n", ""]);

// exports
